
import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import * as firebase from 'firebase';
import { Link } from 'react-router';
import moment from 'moment-es6';
import { camelCaseToRegularCase } from './utils/helper';
const { Toolbar, Data: { Selectors }, Editors: { CheckboxEditor } } = require('react-data-grid-addons');

// You can reuse the formatters from Orders.js by importing them
// For simplicity, I'm redefining them here.

class OrderLinkFormatter extends Component {
  render() {
    return (
      <div>
        <Link to={`/archived-order/${this.props.value}`}>{ this.props.value }</Link>
      </div>
    );
  }
}

const DateFormatter = (p) => {
  const m = moment(p.value, 'YYYY-MM-DD HH:mm:ssA');
  return (
    <div style={{display: 'flex', flexDirection: 'column'}}>
      <p>{m.format('DD/MMM/YY - HH:mm:ssA')}<span style={{fontSize: '0.6em', color: 'darkgray'}}>({m.fromNow()})</span></p>
    </div>
  )
}

const ProductFormatter = (p) => {
  return (
    <div className="capitalize">{camelCaseToRegularCase(p.value)}</div>
  );
}

const PriceFormatter = (p) => {
  const num = parseFloat(p.value);
  if (isNaN(num)) {
    return (<div>-</div>);
  }
  return (
    <div>₹{num.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</div>
  );
}

const WeightFormatter = (p) => {
  const num = parseFloat(p.value);
  if (isNaN(num)) {
    return (<div>-</div>);
  }
  return (
    <div>{num.toLocaleString('en-IN', { maximumFractionDigits: 3 })} tons</div>
  );
}


class ArchivedOrders extends Component {

  constructor(props) {
    super(props);

    this.data = {
      dbRef: firebase.database().ref()
    }

    this._columns = [
        { key: 'isSelected', name: '', editor: <CheckboxEditor/>, width: 35 },
        { key: 'id', name: 'ORDER ID', resizable: true, sortable: true, width: 200, locked: true, formatter: OrderLinkFormatter },
        { key: 'ts', name: 'DATE', resizable: true, sortable: true, formatter: DateFormatter },
        { key: 'agent', name: 'Agent ', resizable: true, sortable: true, minWidth: 200 },
        { key: 'partyDetails', name: 'Party', resizable: true, sortable: true, minWidth: 200 },
        { key: 'product', name: 'PRODUCT', resizable: true, sortable: true, minWidth: 150, formatter: ProductFormatter },
        { key: 'agentPrice', name: 'AGENT PRICE', resizable: true, sortable: true, minWidth: 150, formatter: PriceFormatter },
        { key: 'quantityInTons', name: 'TOTAL WEIGHT', resizable: true, sortable: true, minWidth: 150, formatter: WeightFormatter },
        { key: 'area', name: 'AREA', resizable: true, sortable: true, minWidth: 200 },
        { key: 'status', name: 'STATUS', resizable: true, sortable: true, minWidth: 200 },
    ];

    this.state = {
      allRows: [],
      rows: [],
      currentPage: 1,
      rowsPerPage: 100,
      searchTerm: '',
      selectedRows: [],
      fromDate: '',
      toDate: ''
    };
  }

  componentDidMount() {
    const that = this;
    const archivedOrdersRef = this.data.dbRef.child('archive/o');
    archivedOrdersRef.once('value', snapshot => {
      let tablerows = [];
      const archivedOrdersByDate = snapshot.val();
      for (let date in archivedOrdersByDate) {
        const orders = archivedOrdersByDate[date];
        for (let orderId in orders) {
          const order = orders[orderId];
          const agentName = order.agent.name || order.agent;
          delete order.agent;
          tablerows.push({...order, agent: agentName});
        }
      }
      const sortedRows = tablerows.sort((a,b) => new Date(b.ts) - new Date(a.ts));
      that.setState({
         allRows: sortedRows,
         rows: sortedRows
      });
    });
  }

  rowGetter(i) {
    const { currentPage, rowsPerPage, selectedRows } = this.state;
    const startIndex = (currentPage - 1) * rowsPerPage;
    const row = this.getVisibleRows()[startIndex + i];
    return {...row, isSelected: selectedRows.some(r => r.id === row.id)};
  }

  rowsCount() {
    const { currentPage, rowsPerPage } = this.state;
    const startIndex = (currentPage - 1) * rowsPerPage;
   return Math.min(this.getVisibleRows().length - startIndex, rowsPerPage);
  }

  handleSearch = (e) => {
    this.setState({ searchTerm: e.target.value, currentPage: 1 });
  }

  handlePageChange = (newPage) => {
    this.setState({
        currentPage: newPage
    });
  }

  handlePageSizeChange = (e) => {
    this.setState({
        rowsPerPage: parseInt(e.target.value),
        currentPage: 1
    });
  }

  onRowsSelected = (rows) => {
    this.setState({selectedRows: this.state.selectedRows.concat(rows.map(r => r.row))});
  }

  onRowsDeselected = (rows) => {
    let rowIds = rows.map(r => r.row.id);
    this.setState({selectedRows: this.state.selectedRows.filter(r => rowIds.indexOf(r.id) === -1 )});
  }

  selectAll = () => {
    this.setState({ selectedRows: this.state.rows });
  }

  deselectAll = () => {
    this.setState({ selectedRows: [] });
  }

  getVisibleRows = () => {
    const { allRows, fromDate, toDate, searchTerm } = this.state;
    let filteredRows = allRows;

    if (searchTerm) {
        filteredRows = filteredRows.filter(row => {
            return Object.values(row).some(value =>
                String(value).toLowerCase().includes(searchTerm.toLowerCase())
            );
        });
    }

    if (fromDate && toDate) {
        const from = moment(fromDate).startOf('day');
        const to = moment(toDate).endOf('day');
        filteredRows = filteredRows.filter(r => {
            const m = moment(r.ts, 'YYYY-MM-DD HH:mm:ssA');
            return m.isBetween(from, to);
        });
    }
    return filteredRows;
  }

  handleFromDateChange = (e) => {
    this.setState({ fromDate: e.target.value, currentPage: 1 });
  }

  handleToDateChange = (e) => {
    this.setState({ toDate: e.target.value, currentPage: 1 });
  }

  downloadOrdersCsv = () => {
    const { allRows, fromDate, toDate } = this.state;
    let filteredRows = allRows;

    if (fromDate && toDate) {
        const from = moment(fromDate).startOf('day');
        const to = moment(toDate).endOf('day');
        filteredRows = allRows.filter(r => {
            const m = moment(r.ts, 'YYYY-MM-DD HH:mm:ssA');
            return m.isBetween(from, to);
        });
    }

    const columnDefs = (this._columns || []).filter(c => !!c && !!c.key && c.key !== 'isSelected');

    if (!filteredRows.length) {
      alert('No orders to export');
      return;
    }

    const headers = columnDefs.map(c => c.name || c.key);
    const escapeCsv = (val) => {
      if (val === undefined || val === null) return '';
      const s = String(val);
      if (s.includes('"') || s.includes(',') || s.includes('\n')) {
        return `"${s.replace(/"/g, '""')}"`;
      }
      return s;
    };

    const valueFor = (row, key) => {
      const v = row[key];
      if (key === 'product') {
        return camelCaseToRegularCase(v);
      }
      return v;
    };

    const lines = [];
    lines.push(headers.join(','));
    filteredRows.forEach(row => {
      const fields = columnDefs.map(c => escapeCsv(valueFor(row, c.key)));
      lines.push(fields.join(','));
    });

    const csvContent = '\uFEFF' + lines.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'archived-orders.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  render() {
    const { currentPage, rowsPerPage, searchTerm } = this.state;
    const visibleRows = this.getVisibleRows();
    const totalPages = Math.ceil(visibleRows.length / rowsPerPage);

    return (
      <div tabTitle="Archived Orders" className="py-8 mx-8 mx-auto">
        <h1 className='text-3xl text-green-600 text-center mx-auto'>Archived Orders</h1>
        <div className="py-4 flex justify-between items-center">
            <div>
                <button onClick={this.selectAll} className="bg-blue-600 text-white px-3 py-1 rounded mr-2">Select All</button>
                <button onClick={this.deselectAll} className="bg-blue-600 text-white px-3 py-1 rounded">Deselect All</button>
            </div>
            <div className="flex-grow">
                <input
                    type="text"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={this.handleSearch}
                    className="border rounded px-2 py-1 w-1/2 ml-4"
                />
            </div>
            <div style={{width: '200px'}}>
                <select onChange={this.handlePageSizeChange} value={this.state.rowsPerPage} className="border rounded px-2 py-1 w-full">
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                </select>
            </div>
        </div>
        <div className="py-4 flex justify-end items-center">
            <div className="flex items-center">
                <label className='mr-2 text-sm text-gray-700'>From:</label>
                <input
                    type='date'
                    value={this.state.fromDate}
                    onChange={this.handleFromDateChange}
                    className='border rounded px-2 py-1'
                />
                <label className='ml-4 mr-2 text-sm text-gray-700'>To:</label>
                <input
                    type='date'
                    value={this.state.toDate}
                    onChange={this.handleToDateChange}
                    className='border rounded px-2 py-1'
                />
                <button onClick={this.downloadOrdersCsv} className='bg-blue-600 text-white px-3 py-1 rounded ml-4'>Download CSV</button>
            </div>
        </div>
        <ReactDataGrid
          columns={this._columns}
          rowGetter={this.rowGetter.bind(this)}
          rowsCount={this.rowsCount()}
          minHeight={this.rowsCount() * 37 + 40}
          enableRowSelect={true}
          rowSelection={{
            showCheckbox: true,
            enableShiftSelect: true,
            onRowsSelected: this.onRowsSelected,
            onRowsDeselected: this.onRowsDeselected,
            selectBy: {
              isSelectedKey: 'isSelected'
            }
          }}
        />
        <div className="py-4 flex justify-between items-center">
            <div>
                <span>Page {currentPage} of {totalPages}</span>
            </div>
            <div>
                <button
                    onClick={() => this.handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="bg-gray-300 px-3 py-1 rounded mr-2"
                >
                    Previous
                </button>
                <button
                    onClick={() => this.handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="bg-gray-300 px-3 py-1 rounded"
                >
                    Next
                </button>
            </div>
        </div>
        <footer>© MRP Solutions 2017</footer>
      </div>
    );
  }
}

export default ArchivedOrders;



/** WEBPACK FOOTER **
 ** ./src/ArchivedOrders.js
 **/